// extracted by css-extract-rspack-plugin
export default {"cls1":"SourceForm-cls1_ulo","cls2":"SourceForm-cls2_wCE SourceForm-cls1_ulo"};